/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.0.1
 * @since 1.0.0
 */
import {
    backgroundColorHoverOpacity,
    backgroundColorWhite,
    ColorGrey6,
    ColorGreyLight2,
    textColor,
    textColorOpacity,
} from './palette';

export const superSearchBgColor = backgroundColorWhite;
export const superSearchBgHoverColor = backgroundColorHoverOpacity;
export const superSearchText = textColor;
export const superSearchTextSecondary = textColorOpacity;
export const superSearchBgLoader = `linear-gradient(
    to right,
    ${ColorGreyLight2} 8%,
    ${ColorGrey6} 33%, 
    ${ColorGreyLight2} 60%)`;
